/* eslint react/no-multi-comp: 0 */
/* global __CLIENT__*/
import PropTypes from 'prop-types';

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Map } from 'immutable';

import immutableCreatorSelector from '../../selectors/immutableCreatorSelector';
import { currentUserSelector } from '../../reducers/users';
import { ModalActions } from '../../actions/modal';
import { UserActions } from '../../actions/user';
import { ProjectActions } from '../../actions/project';

import BasicCreateButton from '../../components/buttons/BasicCreateButton/';
import UserForm from '../../components/form/UserForm';

import { currentProjectIdSelector } from '../../reducers/projects';
import { projectRoleSelector } from '../../reducers/users';
import { pendingUsersSelector } from '../../reducers/pendingUsers';
// import '../../styles/ProjectUsers.css';

class ProjectUsers extends Component {
  static propTypes = {
    currentProjectId: PropTypes.string,
    usersMap: PropTypes.instanceOf(Map),
    pendingUsers: PropTypes.instanceOf(Map),
    dispatch: PropTypes.func,
    initialValues: PropTypes.object,
    user: PropTypes.object,
    projectRole: PropTypes.number,
  };

  toggleModal = () => {
    const { dispatch } = this.props;

    dispatch(ModalActions.toggleModal({
      name: 'AddProjectUserModal',
    }));
  };

  removeUserCallback = (currentProjectId, userId) => {
    const {
      dispatch,
    } = this.props;

    dispatch(ProjectActions.removeProjectUser(currentProjectId, userId));
  }

  removePendingUserCallback = (currentProjectId, userId) => {
    const {
      dispatch,
    } = this.props;
    // console.log('Remove Pending User', currentProjectId, userId);
    dispatch(ProjectActions.removePendingProjectUser(currentProjectId, userId));
  }

  changeUserRoleCallback = (currentProjectId, userId, roleId) => {
    const {
      dispatch,
    } = this.props;

    dispatch(ProjectActions.changeUserRole(currentProjectId, userId, roleId));
  }

  render() {
    const {
      usersMap,
      initialValues,
      currentProjectId,
      user,
      dispatch,
      projectRole,
      pendingUsers,
    } = this.props;

    let userCount = usersMap ? usersMap.size : '';
    // console.log('pending users: ', pendingUsers);
    return (<div className="row tab-content-wrapper" style={{ flex: 1 }}>
      <div className="col-md-12 project-default-left-col">
        <BasicCreateButton
          className="btn btn-primary btn-sm"
          onClick={::this.toggleModal}
          style={{ float: 'right' }}
          data-test="addUserButton"
        >
          <i className="fa fa-plus"></i> Add User
        </BasicCreateButton>
        <h2 style={{ fontSize: 20 }}>
          Number of Active Users: <span className="label label-default">
            {userCount}
          </span>
        </h2>
        <UserForm
          removeUserCallback={this.removeUserCallback}
          changeUserRoleCallback={this.changeUserRoleCallback}
          removePendingUserCallback={this.removePendingUserCallback}
          usersMap={usersMap}
          pendingUsers={pendingUsers}
          user={user}
          initialValues={initialValues}
          formObjectId={currentProjectId}
          dispatch={dispatch}
          role={projectRole}
        />
      </div>
    </div>);
  }
}

const projectsUsersSelector = (state) => state.projectsUsers.get('projectsUsers');
const usersMapSelector = (state) => {
  const currentProjectId = currentProjectIdSelector(state);
  const projectUsers = projectsUsersSelector(state).getIn([currentProjectId], []);
  // console.log('SUPPOSE TO BE HERE', projectUsers);
  // const usersMap = state.projectsUsers.get('projectsUsers');
  const usersMap = state.users.get('users');
  const projectUsersMap = usersMap.filter((u, k) => projectUsers.has(k));

  // const roles = state.roles.get('roles');

  // console.log('Project usersMap: ', usersMap);
  if (projectUsersMap.size === 0) return null;
  return projectUsersMap;

  // if (usersMap.size > 1) debugger;

  // const x = usersMap.map((user) => {
    // console.log('user: ', user);
    // return user.set('user', state.users.getIn(['users', user.get('id')]));
    // .set('role', roles.get(user.get('role')));
  // });
  // console.log('project users map from selector', x);
  // return x;
};

const ProjectUsersContainerSelector = immutableCreatorSelector(
  [currentProjectIdSelector, currentUserSelector, usersMapSelector,
   projectRoleSelector, pendingUsersSelector],
  (currentProjectId, user, usersMap, projectRole, pendingUsers) => ({
    currentProjectId,
    user,
    usersMap,
    projectRole,
    pendingUsers,
    initialValues: {
      usersMap: (usersMap) ?
        usersMap.toIndexedSeq().map(pu => ({ role: pu.getIn(['role']) }))
        .toJS() : [],
      pendingUsers: (pendingUsers) ?
        pendingUsers.toIndexedSeq().toJS() : [],
    },
  })
);

@connect(ProjectUsersContainerSelector)
export default class ProjectUsersContainer extends Component {
  static propTypes = {
    currentProjectId: PropTypes.string,
    usersMap: PropTypes.instanceOf(Map),
    pendingUsers: PropTypes.instanceOf(Map),
    dispatch: PropTypes.func,
    projectRole: PropTypes.number,
    user: PropTypes.object,
  };

  componentDidMount() {
    const { dispatch, currentProjectId } = this.props;
    dispatch(UserActions.getProjectUsers(currentProjectId));
  }

  render() {
    // console.log(this.props);
    if (!this.props.usersMap) return <span />;
    // console.log('this.props', this.props);
    return <ProjectUsers {...this.props} />;
  }
}



// WEBPACK FOOTER //
// ./src/views/ProjectSettings/ProjectUsers.js